export const getAuthHeaders = () => {
  const token = localStorage.account_token;
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  }
}